export class CuestionarioRespuesta {
    cuestionarioRespuestaId: number
    cuestionarioPreguntaId: number
    titulo: string
    ponderacion: number
}
